import { AuditEventType, AuditTrailFilters } from '../../../../../backend/src/auditTrail/auditTrail.types';
import {
  FilterField,
  ServerSideFilterPopover as GenericServerSideFilterPopover,
} from '@/new/components/server-side-filter-popover';

interface AuditTrailFilterPopoverProps {
  filters: AuditTrailFilters;
  onFiltersChange: (filters: AuditTrailFilters) => void;
  clearAllFilters: () => void;
}

const filterFields: FilterField[] = [
  {
    type: 'select',
    key: 'auditEventType',
    label: 'Audit Event',
    placeholder: 'Select event type...',
    options: [
      // Matter events
      { value: AuditEventType.CreatedMatter, label: 'Created Matter' },
      { value: AuditEventType.UpdatedMatter, label: 'Updated Matter' },
      { value: AuditEventType.DeletedMatter, label: 'Deleted Matter' },
      { value: AuditEventType.AddedUserMatter, label: 'Added User to Matter' },
      { value: AuditEventType.RemovedUserMatter, label: 'Removed User from Matter' },
      // Subset events
      { value: AuditEventType.CreatedSubset, label: 'Created Subset' },
      { value: AuditEventType.UpdatedSubset, label: 'Updated Subset' },
      { value: AuditEventType.DeletedSubset, label: 'Deleted Subset' },
      // Run events
      { value: AuditEventType.CreatedRun, label: 'Created Run' },
      // Document events
      { value: AuditEventType.CreatedDocument, label: 'Uploaded Documents' },
      { value: AuditEventType.DeletedDocument, label: 'Deleted Document' },
      // Fact events
      { value: AuditEventType.CreatedFact, label: 'Created Fact' },
      { value: AuditEventType.UpdatedFact, label: 'Updated Fact' },
      { value: AuditEventType.ArchivedFact, label: 'Archived Fact' },
      // Chronology events
      { value: AuditEventType.CreatedChronology, label: 'Created Chronology' },
      { value: AuditEventType.DeletedChronology, label: 'Deleted Chronology' },
      { value: AuditEventType.AddedFactToChronology, label: 'Added Fact to Chronology' },
      // Doc Chronology events
      { value: AuditEventType.CreatedDocChronology, label: 'Created Doc Chronology' },
      { value: AuditEventType.DeletedDocChronology, label: 'Deleted Doc Chronology' },
      { value: AuditEventType.AddedDocumentToDocChronology, label: 'Added Document to Doc Chronology' },
      // Comment events
      { value: AuditEventType.AddedCommentToFact, label: 'Added Comment to Fact' },
      { value: AuditEventType.UpdatedComment, label: 'Updated Comment' },
      { value: AuditEventType.DeletedComment, label: 'Deleted Comment' },
      // Realtime events
      { value: AuditEventType.CreatedRealtime, label: 'Started Realtime Session' },
      // Kim Thread events
      { value: AuditEventType.CreatedKimThread, label: 'Created Kim Thread' },
      { value: AuditEventType.DeletedKimThread, label: 'Deleted Kim Thread' },
    ],
  },
  {
    type: 'dateRange',
    startKey: 'startDate',
    endKey: 'endDate',
    label: 'Event Date Range',
  },
];

export function AuditTrailFilterPopover({ filters, onFiltersChange, clearAllFilters }: AuditTrailFilterPopoverProps) {
  return (
    <GenericServerSideFilterPopover
      filters={filters}
      onFiltersChange={onFiltersChange}
      clearAllFilters={clearAllFilters}
      fields={filterFields}
    />
  );
}
